import React, { useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';

import IconButton from 'components/common/IconButton';
import { FILTER_TYPES } from 'constants/filterType';

const useTableExport = ({ exportApi, filters, sorting, filterOptions }) => {
  const handleExport = useCallback(async () => {
    try {
      const params = new URLSearchParams();

      const optionsArray = Array.isArray(filterOptions)
        ? filterOptions
        : filterOptions?.options;

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          const filterOption = optionsArray?.find(opt => opt.field === key);

          if (filterOption?.type === FILTER_TYPES.MULTI_TEXT) {
            const values = value
              .split('\n')
              .map(item => item.trim())
              .filter(item => item !== '');

            values.forEach(v => {
              if (v !== undefined && v !== null && v !== '') {
                params.append(key, v);
              }
            });
          } else if (Array.isArray(value)) {
            value.forEach(v => {
              if (v !== undefined && v !== null && v !== '') {
                params.append(key, v);
              }
            });
          } else if (value !== undefined && value !== null && value !== '') {
            params.set(key, value);
          }
        });
      }

      if (Array.isArray(sorting) && sorting.length > 0) {
        sorting.forEach(({ id, desc }) => {
          params.append('sort', desc ? `-${id}` : id);
        });
      }

      await exportApi?.(params);
      toast.success('Export successfully');
    } catch (error) {
      toast.error('Failed to export');
    }
  }, [exportApi, filters, sorting, filterOptions]);

  const exportButton = useMemo(
    () =>
      exportApi ? (
        <IconButton
          variant="falcon-default"
          size="sm"
          onClick={handleExport}
          icon="arrow-down"
          transform="shrink-3"
        >
          <span className="d-none d-sm-inline-block">
            {filterOptions?.title ? filterOptions.title : 'Download List'}
          </span>
        </IconButton>
      ) : null,
    [exportApi, handleExport, filterOptions],
  );

  return {
    exportButton,
    handleExport,
  };
};

export default useTableExport;
